import { prop } from "fw";

export class Loader {
    @prop(200) private delay!: number;

    private show = false;

    public attached() {
        this.delay > 0 ? setTimeout(() => (this.show = true), this.delay) : (this.show = true);
    }
}
